
const StatusColaborador = {
    regularizado: 1,
    suspenso: 2,
    afastado: 3
}


export default StatusColaborador;